import React from "react";
import UploadedFileList from "./UploadedFileList";
import "./FileUploadPanelLayout.css";

export const UploadChooseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
      stroke="#1976d2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 8L12 3L7 8"
      stroke="#1976d2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 3V15"
      stroke="#1976d2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Full-width upload card: left col (title, format note, helper) + right col (choose files or custom control).
 * Optional file list or footer below.
 */
const FileUploadPanelLayout = ({
  title,
  formatNote,
  helperText,
  chooseLabel = "Choose Files",
  inputRef,
  accept,
  multiple = true,
  onChange,
  disabled = false,
  onChooseClick,
  chooseStyle = {},
  totalHint = null,
  rightContent = null,
  files = [],
  onOpen,
  onRemove,
  footerContent = null,
  className = "",
  invalid = false,
  required = false,
  inputHidden = true,
  /** Omit outer upload-card when nested inside a shared panel (checklist media section only). */
  embedded = false,
}) => {
  const labelStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    border: "1px dashed #cccccc",
    fontWeight: "bold",
    padding: "10px",
    ...chooseStyle,
  };

  const showFileList = files.length > 0 && (onOpen || onRemove);

  const rootClass = [
    embedded ? "file-upload-panel-layout--embedded" : "upload-card",
    "file-upload-panel-layout",
    invalid ? "is-invalid" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClass}>
      <div className="row g-3 align-items-stretch">
        <div className="col-md-6">
          <div className="upload-card-header">
            <div
              className={`file-upload-panel-title-wrap${required ? " required" : ""}`}
            >
              {title}
            </div>
            {formatNote ? <span className="upload-note">{formatNote}</span> : null}
          </div>
          {helperText ? <div className="upload-helper">{helperText}</div> : null}
        </div>

        <div className="col-md-6 file-upload-panel-choose-col">
          {rightContent || (
            <>
              <label className="upload-choose" onClick={onChooseClick} style={labelStyle}>
                <UploadChooseIcon />
                {chooseLabel}
                <input
                  ref={inputRef}
                  type="file"
                  accept={accept}
                  multiple={multiple}
                  onChange={onChange}
                  disabled={disabled}
                  style={inputHidden ? { display: "none" } : undefined}
                  hidden={inputHidden}
                />
              </label>
              {totalHint ? <div className="file-upload-panel-total">{totalHint}</div> : null}
            </>
          )}
        </div>

        {showFileList ? (
          <div className="col-12">
            <UploadedFileList files={files} noTopMargin onOpen={onOpen} onRemove={onRemove} />
          </div>
        ) : null}

        {footerContent ? <div className="col-12">{footerContent}</div> : null}
      </div>
    </div>
  );
};

export default FileUploadPanelLayout;
